import React from 'react';
import styled from 'styled-components';

import Modal from './Modal';
import Alert from '../../Alert';
import Button from '../../other-components/Button';

const Header = styled.div`
    height: 40px;
    display: flex;
    font-weight: 500;
    padding-left: 15px;
    align-items: center;
    justify-content: space-between;
    color: ${({ theme }) => theme.titleText};
    border-bottom: 1px solid ${({ theme }) => theme.inputBorder};
`;

const ModalInner = styled.div`
    width: 350px;
    border-radius: 5px;
    transform: translateY(-50%);
    box-shadow: 0 0 60px 0 rgba(43, 53, 86, 0.15);
    background: ${({ theme }) => theme.primary.bg};
`;

const ModalBody = styled.div`
    padding: 15px;
`;

function QuickFontFamily({ onChange, close, heading, children, value }) {
    return (
        <Modal>
            <ModalInner>
                <Header>
                    {heading}
                    <Button
                        size="sm"
                        type="none"
                        onClick={close}
                        icon={['far', 'times']}
                    />
                </Header>
                <ModalBody>
                    <Alert type="info" style={{ fontSize: 13 }}>
                        Change will be effective on similar elements throughout
                        the site
                    </Alert>
                    <br />
                    {children}
                </ModalBody>
            </ModalInner>
        </Modal>
    );
}

export default QuickFontFamily;
